var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetintouchcall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.287 17.6659L18.8182 15.3221C18.5846 15.2225 18.3249 15.2015 18.0783 15.2623C17.8318 15.3231 17.6116 15.4623 17.451 15.659L15.0291 18.618C11.2281 16.8259 8.16919 13.767 6.37706 9.96604L9.3361 7.54412C9.53321 7.3838 9.67272 7.16363 9.73352 6.91694C9.79431 6.67024 9.77307 6.41046 9.67302 6.17691L7.32923 0.708066C7.21942 0.456308 7.0252 0.250756 6.78007 0.126854C6.53494 0.00295178 6.25426 -0.031534 5.98643 0.0293429L0.908219 1.20124C0.649996 1.26087 0.419609 1.40626 0.25466 1.61369C0.0897111 1.82112 -5.94839e-05 2.07833 2.95718e-08 2.34335C2.95718e-08 14.868 10.1515 25 22.6566 25C22.9217 25.0002 23.1791 24.9104 23.3866 24.7455C23.5941 24.5805 23.7396 24.3501 23.7992 24.0918L24.9711 19.0136C25.0316 18.7444 24.9964 18.4626 24.8715 18.2166C24.7467 17.9707 24.54 17.7759 24.287 17.6659Z",
    fill: "#D90B42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetintouchcall);
export default __webpack_public_path__ + "static/media/getintouchcall.529292e2934bb9d815741df2c00e6d30.svg";
export { ForwardRef as ReactComponent };